module.exports = __webpack_public_path__ + "static/img/physical_harm_3.e1be1f1e.png";